import axios from "axios";
import { baseURL } from "config";

async function getChatDropdown(entity?: string) {
  const params = {
    entity: entity
  };

  const res = await axios.get(`${baseURL}/admin/chat-dropdown`, { params });
  return res.data;
}

export default getChatDropdown;
